import React,{ useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LeadsApi } from '../services/Apis';
import * as Actions from '../store/actions';
import * as authActions from '../services/auth/store/actions';
import { BrandsApi } from '../services/Apis';
import { Alert } from '@material-ui/lab';
import { CustomLabel, CustomButton } from "@tracknme/material-ui";
import alertMessage from '../services/alertMessage';
import MenuLeftStep1 from '../components/menu/left/steps/step_1';
import MenuLeftStep2 from '../components/menu/left/steps/step_2';
import HelpNick from '../components/help/nick';
import Backdrop from '../components/backdrop';
import Loading from '../components/loading';
// import TipDemoVideo from '../components/help/tips/demoVideo';
import TipDashboard from '../components/help/tips/dashboard';
import ModalRegiter from '../components/modals/register';
import ModalConfirm from '../components/modals/confirm';
// import ModalVideo from '../components/modals/video';
import Step1 from '../components/steps/step_1';
import Step2 from '../components/steps/step_2';
import Step3 from '../components/steps/step_3';
import Step4 from '../components/steps/step_4';
import Step5 from '../components/steps/step_5';
import WordPress from '../components/wordpress/step_1';
import UserPage from '../components/steps/user';
import AlertSnackbar from '../components/Snackbar/Snackbar';
import '../App.css';
import '../menu.css';


function Page() {


  const dispatch = useDispatch();
  const state = useSelector(({register}) => register.message.state);
  const message = useSelector(({register}) => register.message);
  const { steps, loading, navigation, register } = useSelector(({register}) => register);
  const [isRegisterUser, setRegisterUser ] = useState(false);
  const [step, setStep ] = useState(1);
  const [isCreateBrand, setIsCreateBrand] = useState(false);
  const [leadConfirmation, setLeadConfirmation] = useState(false);
  const [lead, setLead] = useState(null);
  const [isWordpress, setIsWordpress] = useState(null);
  const [isRegisterDisabled, setRegisterDisabled] = useState(false);
  

  
   useEffect(() => {

    const  confirmLead = async (code) =>{
      
     let result = await LeadsApi.confirm(code);

      if(result && result.data ){
        setLead(result.data);
        dispatch(Actions.setLead(result.data));
      }
     
    }

    if(!leadConfirmation ){
      let confirmation = window.location.pathname;
      if(confirmation){
       
        const query = new URLSearchParams(window.location.search);
        const token = query.get('t')
       
        if(confirmation === "/register/user"){
          if(token){
            setRegisterUser(true)
            dispatch(Actions.setStep(-1));
            return 
          }
          setRegisterDisabled(true);
          setLeadConfirmation(true);
          return;
        }

        confirmation = confirmation.replace("register/index.html","")
        confirmation = confirmation.replace("index.html","")
        confirmation = confirmation.replace("register","")
        confirmation = confirmation.replace("/","")
        
        setLeadConfirmation(true);

        if(confirmation === "/wordpress" || confirmation === "wordpress"){
          setIsWordpress(true)
        }else if(confirmation && confirmation.length > 15){
          setLeadConfirmation(confirmation);
          confirmLead(confirmation);
          dispatch(Actions.setStep(2));
        } else {
          setRegisterDisabled(true);
        }
       
      }
    }
    
    }, [leadConfirmation,dispatch ]);
  
  useEffect(() => {

    if(state ){
       setTimeout(() => {
        dispatch(Actions.hideMessage())
       }, 6000);
      }

  }, [state,dispatch ]);

  useEffect(() => {
    if (isRegisterDisabled) {
      document.title = '404 - Página não encontrada';
    }
  }, [isRegisterDisabled]);

  function changeNextStepValue() {

    let currentStep = steps;
    let pageStep = step;  
    
    if(currentStep < 8){
      currentStep ++;
      pageStep ++;
     
      if(!isCreateBrand && pageStep === 6){
        dispatch(Actions.setLoading(true));
        createBrand(pageStep,currentStep)
      }else{
        dispatch(Actions.setStep(currentStep));
        setStep(pageStep)
      }
    }

    dispatch(Actions.setNavigation(true));
  }

  function changeBackStepValue() {
    let currentStep = steps;
    let pageStep = step;      
    
    if(currentStep > 1){
      currentStep --;
      pageStep--;
      dispatch(Actions.setStep(currentStep));
      setStep(pageStep)
    }
  }

  const createBrand = async (pageStep,currentStep) =>{

    let _register = register;
    
    _register.brand.companySize = lead && lead.companySize ? lead.companySize : '';
    
    BrandsApi.register(_register).then(response => {
      dispatch(Actions.setLoading(false));
      dispatch(Actions.setStep(currentStep));
      setStep(pageStep)
      setIsCreateBrand(true)

      let model ={
        brand:response.data.id,
        email:register.administrator.login,
        password:register.administrator.password
      }  

      setTimeout(() => {
        dispatch(authActions.submitLogin(model)); 
      });

      let brand = response.data;

      setTimeout(() => {
        dispatch(Actions.setBrand(brand)); 
      }, 16000);
     
    })
    .catch(error => {

     
      let response = error.response;
        
      dispatch(Actions.setLoading(false));
      let message = "message error"
      if (response) {
        console.log("response",response);
        if (response.status === 400) message = response.data.message;
        if (response.status === 502) message = 'Serviço indisponível, tente novamente em alguns segundos...';
        if (response.status === 500) message = response.data.message;
      }
     
      alertMessage.showErrorMessage(message);

      dispatch(Actions.setNavigation(false));
    });

  }

  if(isWordpress){
    return (<WordPress/>)
  }

  if(isRegisterDisabled){
    return (
      <div className="menu" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center', padding: 24 }}>
          <CustomLabel
            component="h1"
            variant="h4"
            style={{ fontSize: 72, fontWeight: 700, color: '#4D39E9', marginBottom: 8, lineHeight: 1 }}
            label="404"
          />
          <CustomLabel
            component="p"
            style={{ fontSize: 18, color: '#666' }}
            label="Página não encontrada"
          />
        </div>
        <div className="fixedMessage">
          <AlertSnackbar/>
        </div>
      </div>
    );
  }

  
  return (

    <div className="menu">

      {loading &&( <Loading/>)} 

      <div className="containerLeft">          
          {steps < 5 ? (
              <MenuLeftStep1 isUser={isRegisterUser}/>
          ) : (
              <MenuLeftStep2/>
          )}
      </div>
      <div className="containerRight">

          <div className="containerBox">

            {isRegisterUser &&( 
              <UserPage/>
            )}

            
            {(steps === 0 || steps === 1 || steps === 2 )  &&(
               <Step1/>
              
            )}
            {steps === 3 &&(
              <Step2/>
            )}
            {steps === 4 &&(
              <Step3/>
            )}
            {steps === 5 &&(
              <Step4/>
            )}
            {(steps === 6 || steps === 7 || steps === 8 )&&(
              <Step5/>
            )}
            
            {!isRegisterUser &&(
              <div style={{width: "100%",marginTop:30 , height:40, flexDirection:"row"}}>
                  <div style={{width: "62%", height:40, float:'left', marginTop:50}}>
                    <div className="styleContainer">
                      {step > 1 && step < 7 && (
                        <div> <CustomButton  id="button" disabled={false} onClick={() => changeBackStepValue()} variant="outlined" color="primary" label="Retornar"  style={{backgroundColor:"white", marginLeft:10}} /> </div>
                      )}
                    </div>
                  </div>
                  <div style={{width: "38%",float:'right',  flexDirection:"column", height:40, marginTop:50}}>
                    <div className="styleContainer">
                      <div> <CustomLabel id="standard-basic-data-picker" label={"Passo "+step+" – 6"} color="initial" component="h6" variant="h6" style={{ fontSize:10, fontWeight:'400', color:"#929292"}} /></div>
                      <div> <CustomButton  id="button" disabled={navigation} onClick={() => changeNextStepValue()} variant="contained" color="primary" label="Avançar"  style={{marginLeft:15}} /> </div>
                    </div>
                  </div>    
              </div>
             )}
          </div>
      </div>

      {!loading && (
        <> 
           {steps === 0  &&(
             <ModalRegiter/>
           )}
        </>
      ) }

      {steps === 1  &&(
        <ModalConfirm/>
      )}

      {/* {steps === 7  &&(
         <>
           <Backdrop/>
           <ModalVideo/>
           <HelpNick/>
           <TipDemoVideo/> 
         </>
      )} */}

      {(steps === 7 || steps === 8)  &&(
         <>
           <Backdrop/>
           <HelpNick/>
           <TipDashboard/>
         </>
      )}

      {state &&(
        <div className="fixedMessage">
          {message.options.type === 'error' &&(
            <Alert variant="filled" severity="error">
             {message.options.message}
             </Alert>
         )}
          {message.options.type === 'success' &&(
             <Alert variant="filled" severity="success">
             {message.options.message}
            </Alert>
          )}
         </div>
      )} 

      <div className="fixedMessage">
          <AlertSnackbar/>
      </div>

    </div>

  )
}

export default Page;

